import { render, staticRenderFns } from "./RiskCheckCheckList.vue?vue&type=template&id=b17ce89a&scoped=true&"
import script from "./RiskCheckCheckList.vue?vue&type=script&lang=js&"
export * from "./RiskCheckCheckList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17ce89a",
  null
  
)

export default component.exports